import { AlertTriangle } from "@untitledui/icons";
import { Button } from "@/components/base/buttons/button";
import { FeaturedIcon } from "@/components/foundations/featured-icon/featured-icon";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

type LeaveUnfinishedRiskDialogProps = {
  open: boolean;
  onDiscard: () => void;
  onKeepAdding: () => void;
};

export const LeaveUnfinishedRiskDialog = ({ open, onDiscard, onKeepAdding }: LeaveUnfinishedRiskDialogProps) => (
  <Dialog open={open} onOpenChange={(next) => !next && onKeepAdding()}>
    <DialogContent className="max-w-sm gap-0 rounded-xl border-none p-5">
      <FeaturedIcon icon={AlertTriangle} color="warning" theme="light" size="lg" />
      <DialogTitle className="mt-4 text-md font-semibold text-primary">Finish adding this risk?</DialogTitle>
      <DialogDescription className="mt-1 text-sm text-tertiary">
        You started adding a missed risk to this video. If you leave now, it won't be saved.
      </DialogDescription>
      <div className="mt-6 grid grid-cols-2 gap-3">
        <Button color="secondary" size="md" onClick={onDiscard}>
          Discard and leave
        </Button>
        <Button color="primary" size="md" onClick={onKeepAdding}>
          Keep adding
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
